import { Navigate, RouteObject } from "react-router";
import { CalculationRoute } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/calculation-route";
import { CalculationIndexRoute } from "@/routes/processes/[processId]/qpm/calculations/_components/calculation-index-route";
import { RentalRoute } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/rental/rental-route";
import { MaterialRoute } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/material/material-route";
import { InstallationRoute } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/installation/installation-route";
import { ServiceRoute } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/service/service-view";
import { TotalOverviewRoute } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/total/total-overview-route";
import { CalculationRouteNav } from "@/routes/processes/[processId]/qpm/_components/nav-links/calculation-nav";

export const calculationsRoutes: RouteObject[] = [
  {
    index: true,
    element: <CalculationIndexRoute />,
  },
  {
    path: ":calculationId",
    element: <CalculationRoute />,
    children: [
      {
        index: true,
        element: <Navigate to={CalculationRouteNav.MaterialCost} replace />,
      },
      {
        path: CalculationRouteNav.MaterialCost,
        element: <MaterialRoute />,
      },

      {
        path: CalculationRouteNav.Installation,
        element: <InstallationRoute />,
      },
      {
        path: CalculationRouteNav.Service,
        element: <ServiceRoute />,
      },
      {
        path: CalculationRouteNav.Rental,
        element: <RentalRoute />,
      },
      {
        path: CalculationRouteNav.TotalOverview,
        element: <TotalOverviewRoute />,
      },
    ],
  },
];
